module.exports = __webpack_public_path__ + "static/img/button2@2x.9a3c9fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/button2@2x.png
// module id = 411
// module chunks = 1